import { render, staticRenderFns } from "./PhysicalProgressCard.vue?vue&type=template&id=0fb379c8&scoped=true"
import script from "./PhysicalProgressCard.vue?vue&type=script&lang=js"
export * from "./PhysicalProgressCard.vue?vue&type=script&lang=js"
import style0 from "./PhysicalProgressCard.vue?vue&type=style&index=0&id=0fb379c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb379c8",
  null
  
)

export default component.exports